import { useState, MouseEvent } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import MoreVert from "@material-ui/icons/MoreVert";
import Edit from "@material-ui/icons/Edit";
import Timer from "@material-ui/icons/Timer";
import TimerOff from "@material-ui/icons/TimerOff";
// import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useTableActionStyles } from "./styles";
import { AttendanceLocalDepartmentQueue } from "../../../../../../../../../../../../../@types/attendance-local-department-queue";
import QueueFormUpdate from "../../../form/update";
// import GuicheDelete from "../../../queue-delete";

type TableActionsProps = {
  queue: AttendanceLocalDepartmentQueue;
}

export default function TableActions({ queue }: TableActionsProps) {
  const { pathname } = useLocation();
  const { slug, id } = useParams<{ slug: string, id: string }>();
  const { classes } = useTableActionStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          to={`${pathname}/fila/${queue.id}/tempo-servicos`}
        >
          <Timer htmlColor="#706E7A" />
          Serviços
        </MenuItem>
        <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          to={`${pathname}/fila/${queue.id}/tempo-servicos-complementares`}
        >
          <Timer htmlColor="#706E7A" />
          Serviços Complementares
        </MenuItem>
        <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          to={`${pathname}/fila/${queue.id}/excecao-tempo-servicos`}
        >
          <TimerOff htmlColor="#706E7A" />
          Exceção (Serviços)
        </MenuItem>
        <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          to={`${pathname}/fila/${queue.id}/excecao-tempo-servicos-complementares`}
        >
          <TimerOff htmlColor="#706E7A" />
          Exceção (Serviços Complementares)
        </MenuItem>
        <QueueFormUpdate
          departmentId={Number(id)}
          queue={queue}
          slug={slug}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Edit htmlColor="#706E7A" />
              Editar
            </MenuItem>
          }
        />
        {/* <QueueDelete
          queue={queue}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Delete htmlColor="#706E7A" />
              Excluir
            </MenuItem>
          }
        /> */}
      </Menu>
    </>
  );
}
